export { default } from "./ArticleQuote";
